import { CheckCircle2, ScanSearch, Send, Wrench } from "lucide-react";
import { Eyebrow, Item, Reveal, Stagger } from "../components/Reveal";

const STEPS = [
  {
    n: "01",
    icon: Send,
    title: "Solicite",
    text: "O cliente informa o problema ou necessidade.",
  },
  {
    n: "02",
    icon: ScanSearch,
    title: "Analisamos",
    text: "A demanda é avaliada e direcionada para a solução adequada.",
  },
  {
    n: "03",
    icon: Wrench,
    title: "Resolvemos",
    text: "Profissionais são acionados e o serviço é acompanhado.",
  },
  {
    n: "04",
    icon: CheckCircle2,
    title: "Concluído",
    text: "A demanda é finalizada com acompanhamento e transparência.",
  },
];

export const HowItWorks = () => (
  <section id="como-funciona" className="relative py-24 lg:py-32" data-testid="how-it-works-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Eyebrow>Como funciona</Eyebrow>
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-petrol sm:text-3xl lg:text-4xl">
          Você solicita. <span className="text-brand">A Resolv organiza.</span>
        </h2>
        <p className="mt-4 text-base leading-relaxed text-slate-600">
          Quatro etapas. Zero bagunça. Cada demanda segue um fluxo claro, do primeiro contato
          até a confirmação de que está tudo resolvido.
        </p>
      </Reveal>

      <Stagger className="relative mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        <div className="absolute left-0 right-0 top-14 hidden border-t-2 border-dashed border-slate-200 lg:block" />
        {STEPS.map((step) => (
          <Item key={step.n} className="relative" data-testid={`how-step-${step.n}`}>
            <div className="group h-full rounded-2xl border border-slate-200/80 bg-white p-7 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:border-brand/40 hover:shadow-[0_24px_48px_-20px_rgba(0,102,255,0.25)]">
              <div className="flex items-center justify-between">
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-petrol text-white transition-colors duration-300 group-hover:bg-brand">
                  <step.icon className="h-6 w-6" strokeWidth={1.8} />
                </span>
                <span className="font-display text-4xl font-extrabold text-slate-100 transition-colors duration-300 group-hover:text-brand/20">
                  {step.n}
                </span>
              </div>
              <h3 className="mt-6 font-display text-lg font-semibold text-petrol">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{step.text}</p>
            </div>
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);
